import * as camsAndForecastsPath from './camsAndForecastsPath';

export const { mapPath } = camsAndForecastsPath;
export const { geonameMapPath } = camsAndForecastsPath;
export { getBuoyReportPath } from './buoyReportPath';
export { spotGuidePath } from './spotGuidePath';
export { spotReportPath } from './spotReportPath';
export { spotForecastChartsPath } from './forecastChartsPath';
export { default as subregionForecastPath } from './subregionForecastPath';
